import { takeLatest, call, put } from "redux-saga/effects";

import ClientService from "../../../services/Client/ClientService";
import { SET_USER_ACCOUNTS } from "../../accounts/actionTypes";
import { SET_METADATA_FETCH_DATA } from "../../metadata/actionTypes";
import { SET_AUDIO_FILE_FETCH_DATA } from "../../audioFile/actionTypes";
import * as types from "../actionTypes";

export function* getClientsWatcherSaga() {
  yield takeLatest(types.API_V1_GET_CLIENTS_REQUEST, workerSaga);
}

export function* workerSaga() {
  try {
    const data = yield call(ClientService.getUserClients);
    let tooManyClients = false;

    if (Array.isArray(data)) {
      if (data.length === 1) {
        const { id, name, account_label, accounts } = data[0];
        let accountsMap = {};

        accounts.forEach((account, i) => {
          accountsMap[account.id] = i;
          // Converting python naming convention to JS
          accounts[i].metadataLabel = accounts[i].metadata_label;
          accounts[i].accountFields = {
            fields: accounts[i].account_fields.fields,
            fieldsOrder: accounts[i].account_fields.field_order,
            recordedFields: accounts[i].account_fields.recorded_fields,
            booleanFields: accounts[i].account_fields.boolean_fields,
          };
          accounts[i].supportedLanguages = accounts[i].supported_languages;
          delete accounts[i].metadata_label;
          delete accounts[i].account_fields;
          delete accounts[i].supported_languages;
        });

        yield put({
          type: types.API_V1_GET_CLIENTS_SUCCESS,
          payload: {
            id,
            name,
            accountsMap,
            accountLabel: account_label,
          },
        });
        yield put({
          type: SET_METADATA_FETCH_DATA,
        });
        yield put({
          type: SET_AUDIO_FILE_FETCH_DATA,
        });
        yield put({
          type: SET_USER_ACCOUNTS,
          payload: accounts,
        });
      } else if (data.length >= 2) {
        tooManyClients = true;
      }
    }
    return { tooManyClients, error: null };
  } catch (error) {
    yield put({ type: types.API_V1_GET_CLIENTS_FAILURE });
    return { error: error };
  }
}
